module.exports = __webpack_public_path__ + "img/itau-logo.e895dfdb.svg";